/**
 * Pipeline is a protocol: a fixed OpenADS sequence, not a toolbox.
 * Study tools that wrap a case stage land here instead of starting a second runner.
 */

import type { Modality, StageId } from "@/ipc/contract";
import { appActions } from "@/store/appStore";
import { stageMeta } from "./stages";
import { usePipelineSession } from "./session";

export function openProtocolStep(modality: Modality, id: StageId): void {
  const session = usePipelineSession.getState();
  const kind = session.draft.pipelineKind;
  let kindChanged: string | null = null;
  if (modality === "PWI" && kind === "dwi") {
    session.setPipelineKind("combined");
    kindChanged = "This step belongs to the PWI half. The protocol is now DWI + PWI.";
  } else if (modality === "DWI" && kind === "pwi") {
    session.setPipelineKind("combined");
    kindChanged = "This step belongs to the DWI half. The protocol is now DWI + PWI.";
  }
  const next = usePipelineSession.getState();
  next.ensureStage(modality, id);
  next.selectStage(`${modality}:${id}`);
  next.setMode("setup");
  const label = stageMeta(modality, id)?.label ?? id;
  next.setNotice({
    tone: "info",
    message: kindChanged ?? `Protocol step selected: ${label}.`,
    detail: "Other steps stay checked. Uncheck them on the left to run only this one, or use Run this step in Properties.",
  });
  appActions.setActiveTab("pipeline");
}
